import OrdersContent from './components/Orders/OrdersContent';
import useAuth from '../../../../../hooks/global/useAuth';
import NoAuthContent from './components/NoAuth/NoAuthContent';
import PageHeader from '../../../components/headers/PageHeader';
import { useTranslation } from 'react-i18next';

const OrdersTab = () => {
  const { isLoggedIn } = useAuth();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Orders:OrdersTab' });

  return (
    <>
      <PageHeader title={t('title')} hasBackButton={false} />
      {isLoggedIn ? <OrdersContent /> : <NoAuthContent />}
    </>
  );
};

export default OrdersTab;
